<template>
  <div class="container-fluid">
    <form @submit.prevent="onSubmit">
      <b-col lg="12" class="mt-5 mb-5">
        <b-form-row>
          <form-group class="col-lg-4 col-md-4 mb-3 text-right Font" :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">
              <label>نام</label>

              <input v-model="form.name" type="text" class="form-control">

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


          <languageBox class="col-lg-4 col-md-4" v-model="form.language_id" :validation="$v.form.language_id"/>

          <div class="col-lg-4">

            <p>نوع تگ</p>

            <div class="form-check form-check-inline" v-for="(item,index) in tagModelNames">
              <input class="form-check-input" v-model="form.tag_types" type="checkbox" :id="`tag_type_${index}`"
                     :value="index">
              <label class="form-check-label mx-1" :for="`tag_type_${index}`">{{ item }}</label>
            </div>

          </div>

        </b-form-row>
      </b-col>

      <div class="col-12">
        <button type="submit" class="btn btn-primary rounded-pill mt-2 w-100">ثبت</button>
      </div>
    </form>
  </div>
</template>

<script>
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import languageBox from "@/plugin/components/dashboard/Language/LanguageBox.vue";
import {required} from "vuelidate/lib/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {tagModelNames} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Tag";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "TagForm",
  components: {languageBox, FormErrorsManager, FormGroup},
  props: {
    submitFunction: {},
    mode: {}
  },
  data() {
    return {
      form: {
        name: '',
        language_id: '',
        tag_types: [],
      }
    }
  },
  computed: {
    tagModelNames() {
      return tagModelNames
    }
  },
  validations: {
    form: {
      name: {required},
      language_id: {required},
      tag_types: {},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = this.form
        this.submitFunction(form).then(res => {
          let data = res.data.data
          this.$router.push({name: "TagUpdate", params: {id: data.id}})
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }
    },
    async getSingleTag() {
      let tagRouterForm = {
        id: this.$route.params.id
      }
      let res = await this.$store.dispatch('Tag/showSingleTag', tagRouterForm).then(res => {
        let data = res.data.data;
        this.form.id = data.id
        this.form.name = data.name

        this.form.language_id = data.language_id
        document.getElementById(`language_item_${this.form.language_id}`).click();

        this.form.tag_types = data.tag_types.map((item) => {
          return item.model_name
        })
      })


    }
  },
  mounted() {
    if (this.mode == 'update') {
      this.getSingleTag()
    }
  }
}
</script>

<style scoped>

</style>